import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "deliverDialog"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "card"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "已选择卡片数量", -1);
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "运费", -1);
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 泰国用户未开通支付宝/微信支付？");
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "切换支付方式", -1);
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = {
  key: 1,
  class: "pay_type"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "weixin"
}, "微信支付", -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "alipay"
}, "支付宝", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "收货地址", -1);
const _hoisted_15 = {
  class: "detail"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-next"
}, null, -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "收货地址", -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  class: "default"
}, [/*#__PURE__*/_createTextVNode(" 新增收货地址"), /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-next"
})], -1);
const _hoisted_19 = [_hoisted_17, _hoisted_18];
const _hoisted_20 = {
  class: "btns"
};
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_action_sheet, {
    show: $options.deliverVisible,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $options.deliverVisible = $event),
    title: "发货信息确认",
    "close-icon": $data.closeIcon,
    onClosed: $options.closeActionSheet
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("p", null, _toDisplayString($props.card_total) + "张", 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("p", null, _toDisplayString($options.postage_detail), 1)])]), $options.postage > 0 && $options.template_info_loc && $options.template_info_loc.length == 2 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "changePay",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.tabThailand && $options.tabThailand(...args), ["stop"]))
    }, _hoisted_10)) : _createCommentVNode("", true), !$data.env.isWeixin() && !$data.env.isWeibo() && $options.postage != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[1] || (_cache[1] = $event => $options.clickfn('weixin_mina')),
      class: "item"
    }, [_hoisted_12, _createElementVNode("i", {
      class: _normalizeClass(['iconfont', {
        active: $data.pay_resource == 'weixin_mina'
      }, $data.pay_resource == 'weixin_mina' ? 'icon-singleselect' : 'icon-singleunselected'])
    }, null, 2)])) : _createCommentVNode("", true), !$data.env.isWeixin() ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: _cache[2] || (_cache[2] = $event => $options.clickfn('alipay')),
      class: "item"
    }, [_hoisted_13, _createElementVNode("i", {
      class: _normalizeClass(['iconfont', {
        active: $data.pay_resource == 'alipay'
      }, $data.pay_resource == 'alipay' ? 'icon-singleselect' : 'icon-singleunselected'])
    }, null, 2)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), $props.addressItem && JSON.stringify($props.addressItem) != '{}' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "address",
      onClick: _cache[3] || (_cache[3] = (...args) => $options.goToAddressList && $options.goToAddressList(...args))
    }, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("p", null, _toDisplayString($props.addressItem.address_name) + "，" + _toDisplayString($props.addressItem.address_mobile), 1), _createElementVNode("p", null, _toDisplayString($props.addressItem.province) + _toDisplayString($props.addressItem.city) + _toDisplayString($props.addressItem.county) + _toDisplayString($props.addressItem.address), 1), _hoisted_16])])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "address",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.goToAddressList && $options.goToAddressList(...args))
    }, _hoisted_19)), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
      class: "cancel",
      onClick: _cache[5] || (_cache[5] = _withModifiers($event => $options.deliverVisible = false, ["stop"]))
    }, "取消"), _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.deliverGoods && $options.deliverGoods(...args), ["stop"]))
    }, "确认发货")])])]),
    _: 1
  }, 8, ["show", "close-icon", "onClosed"]), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_21), _createElementVNode("iframe", {
    style: {
      "width": "0",
      "height": "0",
      "position": "absolute",
      "opacity": "0",
      "z-index": "-1"
    },
    id: "webActivityShow",
    class: "dragArea list-group iphone-dragArea",
    src: $data.iframeUrl
  }, null, 8, _hoisted_22)]);
}